import type { RouteRecordRaw } from "vue-router";
import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../pages/HomePage.vue";
import TournamentPage from "../pages/TournamentPage.vue";
import SchedulePage from "../pages/SchedulePage.vue";
import LocationPage from "../pages/LocationPage.vue";
import ContactPage from "../pages/ContactPage.vue";
import WhatToBringPage from "../pages/WhatToBringPage.vue";
import SupportPage from "../pages/SupportPage.vue";
import RulesPage from "../pages/RulesPage.vue";
import CateringInformationPage from "../pages/CateringInformationPage.vue";
import TournamentInformationPage from "../pages/TournamentsInformationPage.vue";
import Tournament from "../components/tournament/Tournament.vue";
import CateringPage from "../pages/CateringPage.vue";
import CateringQueuePage from '../pages/CateringQueuePage.vue';
import SignInPage from '../pages/SignInPage.vue';



const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: HomePage,
    meta: { title: "ALTERLAN"},
  },
  {
    path: "/tournaments",
    meta: { title: "ALTERLAN - Tournaments", fromMenu: true },
    children: [
      {
        path: "",
        component: TournamentPage,
      },
      {
        path: ":title",
        component: Tournament,
        meta: { title: "ALTERLAN - Tournament Details" },
      }
    ]
  },
  {
    path: "/schedule",
    component: SchedulePage,
    meta: { title: "ALTERLAN - Schedule", fromMenu: true },
  },
  {
    path: "/alterbyte",
    component: CateringPage,
    name: 'Catering',
    meta: { title: "ALTERLAN - ALTERBYTE", fromMenu: true },
  },
  {
    path: "/information/location",
    component: LocationPage,
    meta: { title: "ALTERLAN - Location", fromMenu: true },
  },
  {
    path: "/information/rules",
    component: RulesPage,
    meta: { title: "ALTERLAN - Rules", fromMenu: true },
  },
  {
    path: "/information/what-to-bring",
    component: WhatToBringPage,
    meta: { title: "ALTERLAN - What to Bring", fromMenu: true },
  },
  {
    path: "/information/support",
    component: SupportPage,
    meta: { title: "ALTERLAN - Support", fromMenu: true },
  },
  {
    path: "/information/tournaments",
    component: TournamentInformationPage,
    meta: { title: "ALTERLAN - Tournaments", fromMenu: true },
  },
  {
    path: "/catering",
    component: CateringInformationPage,
    meta: { title: "ALTERLAN - Catering", fromMenu: true },
  },
  {
    path: "/kitchen-queue",
    component: CateringQueuePage,
    name: 'CateringQueue',
    meta: { title: "ALTERLAN - Kitchen Queue", fromMenu: true },
  },
  {
    path: "/contact",
    component: ContactPage,
    name: 'Contact',
    meta: { title: "ALTERLAN - Contact", fromMenu: true },
  },
  {
    path: "/sign-in",
    component: SignInPage,
    meta: {
      title: "ALTERLAN - Sign In",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/"
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Add navigation guard to handle menu navigation
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title as string;

  // Set fromMenu to true only if we're navigating between pages
  // or if we've visited before (except for direct home page load)
  if (to.path === "/" && from.path === "/") {
    // Keep original meta for direct home page access
    if (to.query.redirect) {
      next({ path: to.query.redirect as string });
      return;
    }
  } else {
    to.meta.fromMenu = true;
  }

  next();
});

export default router;
